import script from "./LandStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandStatus.vue?vue&type=script&setup=true&lang=ts"

import "./LandStatus.vue?vue&type=style&index=0&id=7b243031&lang=less"

const __exports__ = script;

export default __exports__